$(document).on('click', '.dic-validation-try-again', function() {
   $(this).addClass('dic-validation-loading').css('pointer-events', 'none');
});